<template>
  <div id='listing-wrapper'>
    <script type="application/ld+json">
      {{displaySchemaImage()}}
    </script>
    <script type="application/ld+json">
      {{displaySchemaBreadcrumb()}}
    </script>
    <link v-if="this.$route.query.page && this.$route.query.page>1" rel="prev" :href="prevUrl" />
    <link v-if="this.$route.query.page!==pagination.totalPages" rel="next" :href="nextUrl" />
    <link rel="canonical" :href="canonicalUrl" />
    <!--Actual product content-->
    <!-- exc saving info -->
    <ExclusiveSavingsInfo v-if="isSelectedCountryIndia && bannerPlaceHolderForExc && bannerPlaceHolderForExc.status && (isExclusive || exclusiveUser)"
      :isExclusive="isExclusive || exclusiveUser"
      :calculations="calculations"
      :bannerStyle="bannerPlaceHolderForExc && bannerPlaceHolderForExc.styles"
      :bannerMsg="bannerPlaceHolderForExc && bannerPlaceHolderForExc.text"
    />    
    <BannerPlaceHolderMsg
      v-if="isSelectedCountryIndia && bannerPlaceHolderForNonExc && bannerPlaceHolderForNonExc.status && (!isExclusive || !exclusiveUser)"
      :bannerStyle="bannerPlaceHolderForNonExc && bannerPlaceHolderForNonExc.styles"
      :bannerMsg="bannerPlaceHolderForNonExc && bannerPlaceHolderForNonExc.text"
    >
    </BannerPlaceHolderMsg>
    <div class="listing">
      <div class="main-banner-area">
      <GenderTabs
        v-if="!this.$parent.isDesktop && listingType && anyTwoGenderKeysTrue()"
        v-on:updateLandingCategory="getLandingProducts($event)"
        :callerComp="'listing'"
        :tabsCountDataArr="tabsCountData"
      ></GenderTabs>
      <!-- exclusive band at PLP -->
      <div class="text-center exclusive-bar" v-if="!isExclusive && productCategory !== 'reward-points-offer' && bannerPlaceHolderForExclusive && bannerPlaceHolderForExclusive.text && bannerPlaceHolderForExclusive.status" :style="bannerPlaceHolderForExclusive.styles">
        <span style="font-size: 17px;">
          <div class="customcheckbox mr-15 pointer" style="text-transform: unset;">
            <input type="checkbox" name="giftwrap" id="giftwrap" @click="addExclusiveToCartFromBand(EXCLUSIVE_PRODUCTS[2].prod_id)" :checked="isNotifyVisible">
            <label for="" class="mb0">{{bannerPlaceHolderForExclusive.text}}</label>
          </div>
        </span>
      </div>

      <sneakrFilterOption ref="filterSneakerOptions" v-if="this.$refs && this.$refs.filterOptions && this.$refs.filterOptions.sneakerOptions && !this.$parent.isDesktop"
             :sneakerOptions="sneakerdata"/>
      <div :class="[{'minHeight' : setMinHeight}, 'shimmerBgColor']" v-if="this.$route.path !== '/artists/starwars-official-merchandise' && !notFound">
        <div class="mweb-vedio-height" v-if="bannersVedio && bannersVedio.show_video_url && bannersVedio.video_url">
          <VideoPlayer
                :src="$parent.isDesktop ? bannersVedio.video_url : bannersVedio.mobile_video_url"
                :poster="$parent.isDesktop ? bannersVedio.video_thumbnail : bannersVedio.mobile_video_thumbnail"
                :playVideo="true"
              />
        </div>
        <carousel :perPage='1' :navigationEnabled="true" :paginationEnabled="false" navigationNextLabel=" "
                  navigationPrevLabel=" " :autoplay="true" v-if="this.$parent.isDesktop">
          <slide v-for="(bannerImage, index1) in banners.desktop" :key="index1">
              <a
                v-if="navLink" :href="navLink"
                class="pointer d-inline-block w-100"
                v-bannerImageLoad="getBannerImpressionData(index1)"
              >
                <img class="customFade img-auto" :data-url="bannerImage" :alt="listingBannerAlt" width="1500" height="385" @click="bannerClick(index1)"/>
              </a>
              <div v-else v-bannerImageLoad="getBannerImpressionData(index1)">
                <img class="customFade img-auto" :data-url="bannerImage" :alt="listingBannerAlt" width="1500" height="385" />
              </div>
          </slide>
        </carousel>
        <carousel :perPage='1' :navigationEnabled="true" :paginationEnabled="false" navigationNextLabel=" "
                  navigationPrevLabel=" " :autoplay="true" v-else>
          <slide class="" v-for="(bannerImage, index2) in banners.mobile" :key="index2">
            <div class="minHeight shimmerBgColor">
              <a
                v-if="navLink"
                :href="navLink"
                v-bannerImageLoad="getBannerImpressionData(index2)"
              >
                <img class="customFade img-auto" :data-url="bannerImage" :alt="listingBannerAlt" width="768" height="600" @click="bannerClick(index2)"/>
              </a>
              <div v-else v-bannerImageLoad="getBannerImpressionData(index2)">
                <img class="customFade img-auto" :data-url="bannerImage" :alt="listingBannerAlt" width="768" height="600" />
              </div>
            </div>
          </slide>
        </carousel>
      </div>

      <!-- for star wars light dark theme -->
      <div v-if="this.$route.path === '/artists/starwars-official-merchandise' && theme === 'dark-mode'">
        <picture>
          <source media="(max-width: 575px)" srcset="https://tss-static-images.gumlet.io/star-wars/starwars_banner_movile.jpg">
          <source media="(min-width: 576px)" srcset="https://tss-static-images.gumlet.io/star-wars/starwars-darkside-website.jpg">
          <img data-src="https://tss-static-images.gumlet.io/star-wars/starwars-darkside-website.jpg" alt="Star war official merchandise" class="w-100">
        </picture>
      </div>
      <div v-if="this.$route.path === '/artists/starwars-official-merchandise' && theme === 'light-mode'">
        <picture>
          <source media="(max-width: 575px)" srcset="https://tss-static-images.gumlet.io/star-wars/starwars-lightside-mobile.jpg">
          <source media="(min-width: 576px)" srcset="https://tss-static-images.gumlet.io/star-wars/starwars-lightside-website.jpg">
          <img data-src="https://tss-static-images.gumlet.io/star-wars/starwars-lightside-website.jpg" alt="Star war official merchandise" class="w-100">
        </picture>
      </div>


      <div class="text-center exclusive-bar" v-else-if="$route.params.sid === 'scarves' && !isExclusive">
        <span style="font-size: 17px;">
          <div class="customcheckbox mr-15 pointer" style="text-transform: unset;">
            <input type="checkbox" name="giftwrap" id="giftwrap" @click="addExclusive(EXCLUSIVE_PRODUCTS[2].prod_id)">
            <label for="" class="mb0">Become a member to buy these scarves now</label>
          </div>
        </span>
      </div>

      <!-- Start cashback app intallation at PLP -->
      <BannerPlaceHolderMsg
        v-if="bannerPlaceHolderForAPPCashBack &&
        bannerPlaceHolderForAPPCashBack.text && bannerPlaceHolderForAPPCashBack.status && this.allProducts.length > 0"
        :bannerStyle="bannerPlaceHolderForAPPCashBack && bannerPlaceHolderForAPPCashBack.styles"
        :bannerMsg="bannerPlaceHolderForAPPCashBack && bannerPlaceHolderForAPPCashBack.text"
        :toggleCashbackPopup="bannerPlaceHolderForAPPCashBack && bannerPlaceHolderForAPPCashBack.text && bannerPlaceHolderForAPPCashBack.text.toLowerCase() && bannerPlaceHolderForAPPCashBack.text.toLowerCase().includes('cashback') && toggleCashbackPopup"
      >
      </BannerPlaceHolderMsg>
      <!-- End cashback app intallation at PLP -->

      <CountdownPLP
        :starttime="timerData.startDate"
        :endtime="timerData.endDate"
        :color="timerData.timerColor"
        v-if="timerData && timerData.showCountDown && saleDet && !saleDet.enable_daily_drop_web"
        :showTimer="timerData.showTimer"
        :pretext="timerData.liveSaleText"
        v-on:getLiveSaleText="getSaleTextToShow"
        :showEarlyText="timerData.showEarlyText"
        :days="timerData.days"
        :minutes="timerData.minutes"
        :hours="timerData.hours"
        :seconds="timerData.seconds"
        :now="timerData.now"
        :mobileUI="$parent.isDesktop ? false : true"
      />
      </div>
      <div class="container plisting fullWidth">
      <div v-if="notFound">
        <NoProductFoundListing
        :wishlistItemsIDs="wishlistItemsIDs" :updateWishlist="updateWishlist"
        />
      </div>
      <div v-else class="container plisting fullWidth p-0" :class="[ categoriesCard.includes($route.params.sid)? 'no-gutters' : '' ]">
        <div v-if="this.$route.path === '/artists/starwars-official-merchandise'">
          <div class="lined-header mt-3 mb-1">
            <h2>Choose Your Side</h2>
          </div>

          <img data-src="https://tss-static-images.gumlet.io/star-wars/BUTTON.png" usemap="#theme-map" class="d-block m-auto" alt="Choose your side"/>
          <map name="theme-map">
              <area @click="activateDarkTheme" alt="dark side" coords="6,10,194,49" shape="rect">
              <area @click="activateLightTheme" alt="light side" coords="395,10,201,48" shape="rect">
          </map>
        </div>
        <div class="">
          <div class="d-flex justify-content-end ">
            <div class="col-lg-9 col-md-8  pro-list">
              <div class="breadcrumbcustome" v-if="$parent.isDesktop">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-12">
                    <div class="newbread">
                      <router-link to="/">Home</router-link>
                      <span v-if="this.formattedArtistName"> / <router-link :to="this.formattedArtistSlug"><span v-html="formattedArtistName"></span></router-link></span>
                      / <span v-html="formattedArtist"></span>
                      <span v-if="false">
                        <br/>
                        (
                        <u>
                          <router-link to="/mobile-covers">Change phone model</router-link>
                        </u>
                        )
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-between align-items-end align-items-lg-center">
                  <header class="col-lg-6 col-md-6 col-12">
                    <h1 ref="listingHeader" class="list-header" v-if="formattedHeader">{{formattedHeader}}
                      <span v-if="this.$parent.isDesktop" style="color: #878b94;" class="title-count">
                      - {{this.pagination && this.pagination.totalProduct}} items
                      </span>
                    </h1>
                    <span v-if="!this.$parent.isDesktop" style="color: #878b94;" class="title-count">{{this.pagination && this.pagination.totalProduct}} items</span>
                  </header>
                  <sorting-options class="w-full" style="max-width: 235px;" :sortingOptionsData="sortingOptionsData"
                    :sortData=" this.$refs && this.$refs.filterOptions && this.$refs.filterOptions.sorts"/>

                </div>
                <!-- filter chips -->
                <div class="row filter-chips-wrap pt-2" v-if="this.$parent.isDesktop">
                  <div class="filter-chip-card px-2 m-1"
                    v-for="(item, index3) in this.$refs.filterOptions && this.$refs.filterOptions.getSelectedFilterChips"
                    :key="index3"
                  >
                    <span class="p-1">
                      {{['gender', 'size', 'stock', 'sort'].includes(item.alias.toLowerCase()) ? `${item.alias} : ` : ''}}
                      {{item.name}}
                      <svg @click="removeFilterChipHandler(item)" class="pointer" xmlns="http://www.w3.org/2000/svg" id="CloseIcon" width="18" height="18" viewBox="0 0 24 15">
                        <path id="Line_9" d="M12 0L0 12" class="cls-close" transform="translate(6 6)"/>
                        <path id="Line_10" d="M0 0L12 12" class="cls-close" transform="translate(6 6)"/>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- {{busy}}--------- -->
        <div class="row">
          <div class="col-lg-3 col-md-4 col-12 filterCol">
            <div v-if="profilePhoto && this.$parent.isDesktop">
              <div class="artUsericon text-center" v-if="this.$route.path === '/artists/starwars-official-merchandise'">
                <img data-src="https://tss-static-images.gumlet.io/star-wars/Light_artistimage.jpg" v-if="theme==='light-mode'" alt="Star War Artist">
                <img data-src="https://tss-static-images.gumlet.io/star-wars/Dark_artistimage.jpg" v-if="theme==='dark-mode'" alt="Star War Artist">
              </div>
              <div class="artUsericon text-center" v-else>
                <img class="img-auto" :data-src="profilePic" alt="Profile" width="252" height="252">
              </div>
              <div class="artistCont" v-if="isArtistListing">
                <div class="row">
                  <div class="col-md-12 col-sm-12 col-12">
                    <h4 class="hsubnav f18 text-inherit mb-0">{{artistData.firstname.replace('\u0099', '&trade;')}} {{artistData.lastname }}</h4>
                  </div>
                </div>
                <div id="artistinfo" role="tablist" aria-multiselectable="false" class="accordiontabs mt10" v-if="artistData.is_merch === 0">
                  <div class="card">
                    <div class="card-header" role="tab" id="artione">
                      <h5 class="mb-0 flighter">
                        <a data-toggle="collapse" data-parent="#artistinfo" href="#infoone" aria-expanded="false" aria-controls="collapseOne">
                        Artist Info
                        </a>
                      </h5>
                    </div>
                    <div id="infoone" class="collapse" role="tabpanel" aria-labelledby="artione">
                      <div class="card-block">
                        <div v-html="artistData.description"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <filter-options ref="filterOptions" v-on:filterClick="filterListing" v-on:updateSortingOptions="updateSortingOptionsHandler($event)"
                v-on:clearClick="clearFilters" :isKids="webcategory === 'kids' ? true : false"></filter-options>
          </div>
          <div class="col-lg-9 col-md-8 col-12 pro-list">
            <div>
              <transition name="fade">
                <div v-if="loading && mobileCurrentPage === 1" class='spinner-3-wrapper'>
                  <img :src="staticImgServer + 'assets/spinner-3.gif'" class='spinner-3' alt="Loader"/>
                  <p class='loading-txt'>Awesomeness Loading</p>
                </div>
                <div class="row" :class="[ categoriesCard.includes($route.params.sid) ? 'no-gutters p-0' : '', isCarouselImageLoaded && isPlpFirstTimeVisited ? 'animate-container' : '' ]" v-else-if="productsListing.length">
                  <div ref="scrollSentinelTop" style="height: 1px; width: 100%;"></div>
                  <div v-for="(prm, index4) in productsListing" :key="index4" :class="[prm.tiptiles && prm.tiptiles.type === 'TYPE2' ? prm.tiptiles.colWidth && $parent.isDesktop ? `col-${prm.tiptiles.colWidth}` : 'col-12' : 'col-lg-3 col-md-6 col-6 animate-card', prm.tiptiles ? 'd-flex flex-column' : '']">
                    <ProductCard v-if="categoriesCard.includes($route.params.sid)"
                      :image="prm.tiptiles ? $parent.isDesktop ? prm.tiptiles.image : prm.tiptiles.mobileImage : prm.images[0]"
                      :secondaryImage="prm.images && prm.images[1]"
                      alt
                      :slug="prm.product_slug"
                      :name="prm.tiptiles ? prm.tiptiles.name : prm.product"
                      :price="prm.price"
                      :splPrice="prm.splPrice || prm.spl_price"
                      :category="prm.category && prm.category.name"
                      :pstock="prm.stock"
                      :isStockConfig="prm.prodQty"
                      :prodType="prm.prodType"
                      @click.native="productClick({prm, index4})"
                      :scrollToProduct="scrollNow"
                      :isExclusive="isExclusive"
                      :exclusivePrice="prm.exclusivePrice"
                      :product="prm"
                      :plpMockUpTags="plpMockUpTags"
                      :showImageBlurSoldOutDesign="true"
                    />
                    <!-- This block is using for only when cover image coming in API -->
                    <img-block v-else-if="prm && prm.plpCoverImage && prm.isProductLocked"
                      :parry="prm.plpCoverImage ? [prm.plpCoverImage] : prm.images" :position="index4" :imageH="400" :imageW="300"
                      :avgRating="prm.avgRating"
                      :bannerplprating="bannerPLPRating"
                      :ratingCount="prm.ratingCount"
                      :urlKey="prm.product_slug" :productTitle="prm.tiptiles ? prm.tiptiles.name : prm.product" :productCat="prm.artist && prm.artist.name"
                      :productPrice="prm.price" :exclusivePrice="prm.exclusivePrice" :jitValue="prm.jitValue"
                      :pstock="prm.stock" :spprice="prm.splPrice || prm.spl_price" :listCat="prm.category && prm.category.name"
                      :pclass="'prd'+prm.id+ prm.category +'img'" :product="prm" :isStockConfig="prm.prodQty" :scrollToProduct="scrollNow"
                      :prodType="prm.prodType" :togglePopup="togglePopup" @click.native="productClick({prm, index4})" :imageCount="productsListing.length"
                      :plpMockUpTags="plpMockUpTags" :genderType="prm.genderType" :showImageBlurSoldOutDesign="true"
                      :timerData ="timerData && timerData.showCountDown && saleDet && saleDet.enable_daily_drop_web ? timerData : null"
                      :gstInClusiveLabel="bannerPlaceHolderForGstInclusiveLabel"
                      :prm="prm" :wishlistItemsIDs="wishlistItemsIDs" :updateWishlist="updateWishlist" :hideWishlist="hideWishlist" :saleDet="saleDet"
                      callerComp="PLP Page"
                      :headingTitle="headingTitle"
                      @carousel-images-loaded="handleCarouselImagesLoaded"
                    ></img-block>
                    <img-block v-else
                      :size="prm.size ? prm.size : ''"
                      :parry="prm.tiptiles ? $parent.isDesktop ? [prm.tiptiles.image] : [prm.tiptiles.mobileImage] : prm.images" :position="index4" :imageH="400" :imageW="300"
                      :avgRating="prm.avgRating"
                      :bannerplprating="bannerPLPRating"
                      :ratingCount="prm.ratingCount"
                      :urlKey="prm.product_slug" :productTitle="prm.tiptiles ? prm.tiptiles.name : prm.product" :productCat="prm.artist && prm.artist.name"
                      :productPrice="prm.price" :exclusivePrice="prm.exclusivePrice" :jitValue="prm.jitValue"
                      :pstock="prm.stock" :spprice="prm.splPrice || prm.spl_price" :listCat="prm.category && prm.category.name"
                      :pclass="'prd'+prm.id+ prm.category +'img'" :product="prm" :isStockConfig="prm.prodQty" :scrollToProduct="scrollNow"
                      :prodType="prm.prodType" :togglePopup="togglePopup" @click.native="productClick({prm, index4})" :imageCount="productsListing.length"
                      :plpMockUpTags="plpMockUpTags" :genderType="prm.genderType" :showImageBlurSoldOutDesign="true"
                      :timerData ="timerData && timerData.showCountDown && saleDet && saleDet.enable_daily_drop_web ? timerData : null"
                      :gstInClusiveLabel="bannerPlaceHolderForGstInclusiveLabel"
                      :prm="prm" :wishlistItemsIDs="wishlistItemsIDs" :updateWishlist="updateWishlist" :hideWishlist="hideWishlist" :saleDet="saleDet"
                      :callerComp="headingTitle?headingTitle:'PLP Page'"
                      :headingTitle="headingTitle"
                      @carousel-images-loaded="handleCarouselImagesLoaded"
                    ></img-block>
                  </div>
                  <div v-if="loading" class='mt40 mb20 row w-full justify-content-center align-items-center load-more-loader'>
                    <img :src="staticImgServer + 'assets/spinner-3.gif'" class='spinner-3' alt="Loader"/>
                  </div>
                  <div ref="scrollSentinelBottom" style="height: 1px; width: 100%;"></div>
                </div>
                <div v-else>
                    <div class="row justify-content-md-center justify-content-center" style="color:#a79100; font-size:40px;" v-if="this.$route.path === '/artists/now-or-never-sale'">Sale has ended</div>
                    <div v-else>
                      <div v-if="!productsListing.length && (this.$refs.filterOptions && this.$refs.filterOptions.getSelectedFilterChips && this.$refs.filterOptions.getSelectedFilterChips.length || this.showNotFound)" class="mtb20 no-product-list">
                        <transition name="fade">
                          <NoProductFoundListing
                          :wishlistItemsIDs="wishlistItemsIDs" :updateWishlist="updateWishlist"
                          />
                        </transition>
                      </div>
                    </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <exclusive-modal v-if="isNotifyVisible" :addExclusive="addExclusive" :togglePopup="togglePopup" :exclusiveAdded="exclusiveAdded" :removeExcFromCart="removeExcFromCart" />
    <common-pop-up v-if="showCommonPopUp" :title="'Download our mobile app'" :txtArr="txtArr" :setPopup="hideCommonPopUp" />
    <common-msg-pop-up v-if="isCashbackPopup && messageHeadForAPPCashBack.text && messageListForAPPCashBack.length>0" :title="messageHeadForAPPCashBack.text" :txtArr="messageListForAPPCashBack" :setPopup="toggleCashbackPopup" />
  </div>
  <div v-if="isScrollToUpVisible" :class="$parent.isDesktop ? 'dkstickyfooter' : 'dkstickyNew'" class="scroll-to-top-btn" id="scroll-to-top">
    <div v-if="!$parent.isDesktop" class="text-white d-flex align-items-cener justify-content-center" @click="scrollToTop">
      <span class="mobile-new-scrollTop px-2 py-1">
        <span style="font-size: 1.2em;line-height: 0;">&uarr;</span>&nbsp;
        {{formattedHeader}} {{displayProductCount}} / {{this.pagination && this.pagination.totalProduct}}
      </span>
    </div>
    <button v-else class="btn" @click="scrollToTop">
      <i class="fa fa-arrow-up"></i>
    </button>
  </div>
  </div>
</template>
<script>
  var $ = require('jquery')
  window.jQuery = $
  import Vue from 'vue'
  import filterOptions from './common/filterOptions.vue'
  import sortingOptions from './common/sortingOptions.vue'
  import sneakrFilterOption from './common/sneakerFilterOptions.vue'
  import {Carousel, Slide} from 'vue-carousel'
  import carouselSlider from './common/carouselSlider.vue'
  import imgBlock from './common/imgBlock.vue'
  import Loader from './common/loader.vue'
  import placeholderImage from './common/placeholderImage.vue'
  import listingPagination from './common/listingPagination.vue'
  import {metaElements} from '../assets/js/metaElements'
  import {mapGetters, mapState} from 'vuex'
  import infiniteScroll from 'vue-infinite-scroll'
  import CountdownPLP from './common/CountdownPLP'
  import ExclusiveModal from './common/ExclusiveModal.vue'
  import NoProductsFound from './common/NoProductsFound.vue'
  import ExclusiveSavingsInfo from './common/ExclusiveSavingInfo'
  import ProductCard from './winterCollection/Product'
  import BannerPlaceHolderMsg from './common/BannerPlaceHolderMsg'
  import moment from 'moment/src/moment'
  import commonPopUp from './common/commonPopUp'
  import VideoPlayer from './common/VideoPlayer.vue'
  import commonMsgPopUp from './common/commonMsgPopUp'
  import webPush from '@/assets/js/webPushNotification'
  import {sessionStorageMixin} from '../assets/js/appMixins'
  import GenderTabs from './common/GenderTabs.vue'
  import NoProductFoundListing from './common/NoProductFoundListing.vue'
  import { getProductUrl } from '../assets/js/common'
  import debounce from 'lodash/debounce'
  import indexedDb from '../utils/indexedDb'
  export default {
    name: 'listing',
    mixins: [metaElements, sessionStorageMixin],
    components: {
      filterOptions,
      Carousel,
      Slide,
      carouselSlider,
      imgBlock,
      Loader,
      placeholderImage,
      listingPagination,
      CountdownPLP,
      ExclusiveModal,
      NoProductsFound,
      ProductCard,
      ExclusiveSavingsInfo,
      commonPopUp,
      commonMsgPopUp,
      BannerPlaceHolderMsg,
      GenderTabs,
      sortingOptions,
      sneakrFilterOption,
      NoProductFoundListing,
      getProductUrl,
      VideoPlayer
    },
    data () {
      return {
        sneakerdata: [],
        setMinHeight: true,
        plpFirstVisit: false,
        defaultSort: 'DEFAULT',
        profilePhoto: false,
        listingBannerAlt: '',
        showNotFound: false,
        catImgPath: process.env.IMG_BASE_URL + process.env.CATEGORY_IMG,
        tagImgPath: process.env.IMG_BASE_URL + process.env.TAG_IMG,
        artistImgPath: process.env.IMG_BASE_URL + process.env.ARTIST_IMG,
        staticImg: process.env.STATIC_IMG,
        query_filters: null,
        isArtistListing: false,
        breadcrumb: '',
        breadcrumbUrl: '',
        breadcrumbText: '',
        headingTitle: '',
        theme: 'light-mode',
        loading: false,
        banners: {
          desktop: [],
          mobile: []
        },
        bannersVedio: {},
        products: [],
        pagination: {
          currentPage: 1,
          totalPages: -1
        },
        query: {},
        profilePic: '',
        isNotifyVisible: false,
        exclusiveAdded: false,
        EXCLUSIVE_PRODUCT: process.env.EXCLUSIVE_PRODUCT,
        notFound: false,
        emptySearch: false,
        referrerUrl: '',
        PAGE_LIMIT: this.$parent.isDesktop ? 48 : 24,
        now: '',
        startDate: '',
        endDate: '',
        exclusiveDate: '',
        timerColor: '#d99b00',
        liveSaleText: '',
        productCategory: '',
        timerInterval: '',
        scrollLengthY: 0,
        listingUrl: '',
        onloadCount: 1,
        clearFilter: false,
        categoriesCard: [],
        selectedTags: ['girl-power', 'animals', 'black-panther', 'batman', 'captain-america', 'captain-marvel', 'cartoon-network', 'cartoons-comics', 'clearance-sale', 'combos', 'desi', 'disney', 'f-r-i-e-n-d-s', 'film-tv', 'food', 'friends', 'funny', 'gaming', 'geeky', 'hulk', 'iron-man', 'joker', 'patterns', 'punisher', 'save-their-souls', 'solar-activated', 'solids', 'spider-man', 'superheroes', 'superman', 'sweat-activated', 'the-flash', 'thor', 'travel', 'winter-collection', 'wonder-woman', 'x-men'],
        navLink: '',
        timerData: {
          startDate: '',
          endDate: '',
          exclusiveDate: '',
          color: '#d99b00',
          liveSaleText: '',
          showEarlyText: false,
          showTimer: false,
          showCountDown: false,
          showBlur: '',
          now: '',
          days: '',
          minutes: '',
          hours: '',
          seconds: ''
        },
        saleDet: {},
        showCommonPopUp: false,
        isCashbackPopup: false,
        txtArr: [],
        txtMesgArr: [],
        canonicalUrl: '',
        nextUrl: '',
        prevUrl: '',
        wishlistArray: {},
        selectID: [],
        hideWishlist: false,
        onLoadFirstPage: 1,
        onLoadFirstSrollPage: 1,
        mobileCurrentPage: 1,
        mobileProductsList: [],
        observerBottom: null,
        observerTop: null,
        isTopLoading: true,
        isScrollToUpVisible: false,
        bannerPromotionName: '',
        bannerId: '',
        googleAdwordsId: process.env.GOOGLE_ADWORDS_ID,
        staticImgServer: process.env.STATIC_IMG_SERVER2,
        tabsCountData: [
          {
            is_kids: false,
            is_men: false,
            is_women: false
          }
        ],
        isKids: false,
        sortingOptionsData: null,
        pageType: '',
        urlSlug: '',
        selectedGenderTab: '',
        deselectedGenderTab: false,
        averageRate: '',
        ratingcount: '',
        isCarouselImageLoaded: false,
        imgPath: process.env.IMG_BASE_URL + process.env.PRODUCT_IMG
      }
    },
    directives: {infiniteScroll},
    methods: {
      handleCarouselImagesLoaded (value) {
        this.isCarouselImageLoaded = value
      },
      handleMinHeight: debounce(function () {
        if (!this.isBannerAvailable) {
          this.setMinHeight = false
        }
      }, 800),
      animationStorageHandler () {
        if (this.getFromSessionStorage('plp_first_visit') === null) {
          this.saveToSessionStorage('plp_first_visit', true)
        }
      },
      updateSortingOptionsHandler (e) {
        this.sortingOptionsData = e
      },
      scrollToUpVisibile () {
        const listingWrapperEl = document.getElementById('listing-wrapper')
        if (listingWrapperEl) {
          const scrollY = window.scrollY
          return scrollY >= listingWrapperEl.scrollHeight / 5
        }
      },
      updateWishlist: function (item, e) {
        e.stopPropagation()
        if (this.wishlistItemsIDs && item && item.id) {
          const data = {
            category: item.category && item.category.name,
            gender_type: item.genderType && item.genderType.toString(),
            images: item.images,
            parent_prod_id: item.id,
            price: item.price,
            prod_id: item.id,
            prod_type: item.prodType,
            prod_qty: item.prodQty,
            quantity: 1,
            product: item.product,
            size: item.size,
            prArtist: item.artist && item.artist.name.replace('\u0099', '') || '',
            spl_price: item.splPrice || item.spl_price,
            url_key: item.product_slug,
            platform: this.webcategory === 'kids' ? 'KIDS' : this.webcategory
          }
          if (this.wishlistItemsIDs[item.id]) {
            this.$store.dispatch('UPDATE_WISHLIST', {operation: 'delete', type: 'products', data}).then(() => {
              e.target.classList.add('wishlistAnimation')
              setTimeout(function () {
                e.target.classList.remove('wishlistAnimation')
              }, 1000)
            })
          } else {
            this.$store.dispatch('UPDATE_WISHLIST', {operation: 'add', type: 'products', data}).then(() => {
              e.target.classList.add('wishlistAnimation')
              setTimeout(function () {
                e.target.classList.remove('wishlistAnimation')
              }, 1000)
            })
            this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'add_to_wishlist',
              payload: {
                currency: 'INR',
                value: this.isExclusive ? item.exclusivePrice : ((item.splPrice || item.spl_price) && (item.splPrice > 0 || item.spl_price > 0)) ? item.splPrice || item.spl_price : item.price,
                items: [
                  {
                    item_name: data.product,
                    item_id: data.prod_id,
                    price: this.isExclusive ? item.exclusivePrice : ((item.splPrice || item.spl_price) && (item.splPrice > 0 || item.spl_price > 0)) ? item.splPrice || item.spl_price : item.price,
                    item_category: data.category,
                    discount: item.price - (this.isExclusive ? item.exclusivePrice : ((item.splPrice || item.spl_price) && (item.splPrice > 0 || item.spl_price > 0)) ? item.splPrice || item.spl_price : item.price),
                    quantity: data.quantity,
                    currency: 'INR',
                    item_list_name: this.breadcrumb ? this.breadcrumb : 'NA',
                    item_category2: data.size || 'NA',
                    item_brand: 'The Souled Store'
                  }
                ]
              }
            })
            if (this.webpushInitiator) {
              webPush.webpushSubscription().then(() => {
                this.$store.commit('WEBPUSH_INITIATOR', false)
              })
            }
          }
        } else {
          this.$router.push(`/login?redirect=${this.$route.path}`)
        }
      },
      handleAppCashBack: function () {
        this.toggleCommonPopUp()
      },
      toggleCashbackPopup (flag) {
        this.isCashbackPopup = flag
      },
      redirectToStoreInMobileView: function () {
        window.location.href = 'https://bit.ly/appxtss'
      },
      toggleCommonPopUp: function () {
        this.showCommonPopUp = true
      },
      hideCommonPopUp: function () {
        this.showCommonPopUp = false
      },
      scrollNow: function () {
        let scrollInfo = Vue.ls.get('listing-scroll-pos')
        if (scrollInfo && scrollInfo.performScroll && scrollInfo.productId && document.querySelector(`#productlist-${scrollInfo.productId}`)) {
          document && document.querySelector(`#productlist-${scrollInfo.productId}`) && document.querySelector(`#productlist-${scrollInfo.productId}`).scrollIntoView({block: 'center'})
          scrollInfo.performScroll = false
          this.$store.commit('SET_PRODUCT_INFO', {})
          Vue.ls.set('listing-scroll-pos', scrollInfo)
        }
      },
      scrollItem: function () {
        let scrollInfo = Vue.ls.get('listing-scroll-pos')
        if (this.onLoadFirstPage > this.onLoadFirstSrollPage + 1) {
          return
        }
        if (scrollInfo && scrollInfo.productId && document.querySelector(`#productlist-${scrollInfo.productId}`)) {
          const element = document.querySelector(`#productlist-${scrollInfo.productId}`)
          if (element) {
            const yPosition = element.getBoundingClientRect().top + window.scrollY
            window.scrollTo({ top: yPosition })
          }
        }
      },
      scrollToTop: function () {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      },
      formatTime: function (date) {
        let d = date ? new Date(date) : new Date()
        return [
          d.getFullYear(),
          ('0' + (d.getMonth() + 1)).slice(-2),
          ('0' + d.getDate()).slice(-2)
        ].join('-') + ' ' +
          [('0' + d.getHours()).slice(-2),
            ('0' + d.getMinutes()).slice(-2),
            ('0' + d.getSeconds()).slice(-2)
          ].join(':')
      },
      formatDate: function (date) {
        let t = new Date(date.replace(/\s/, 'T') + '+05:30')
        return [
          ('0' + t.getDate()).slice(-2),
          ('0' + (t.getMonth() + 1)).slice(-2),
          t.getFullYear()
        ].join(' / ')
      },
      productClick (data) {
        this.$store.commit('MOENGAGE_EVENT', {
          eventName: 'PLP_LIST_CLICK',
          payload: {
            Product_id: Number(data.prm.id),
            Product_Category: String((data.prm.category && data.prm.category.name) || data.prm.category) || 'NA',
            Product_Name: String(data.prm.product) || 'NA',
            Product_Price: String(data.prm.price) || 'NA',
            Product_Artist: String((data.prm.artist && data.prm.artist.name) || data.prm.artist) || 'NA',
            Quantity: 1,
            Size: String(data.prm.size) || 'NA',
            Product_Image_URL: String(this.imgPath + (data.prm.images && data.prm.images[0])) || 'NA',
            Product_URL: String(this.getProductUrl && this.getProductUrl(true, data.prm.product_slug, data.prm.gender_type)) || 'NA',
            PLP_Index: Number(data.index4) || 'NA'
          }
        })
        let scrollObj = {
          'urlFrom': this.listingUrl,
          'productId': data.prm.id,
          'urlTo': `/product/${data.prm.product_slug}`,
          'scrollLength': this.scrollLengthY,
          'performScroll': false,
          'loadOnce': true,
          'pageNo': data.prm.pageNo
        }
        data && data.prm && data.prm.tiptiles ? this.$store.commit('GTAG_EVENT', {eventName: 'Tiptile_Pressed', payload: {SOURCE: Vue.ls.get('routeObj').previous || 'NA', type: data.prm.tiptiles.type || 'NA', id: data.prm.tiptiles.id || 'NA', name: data.prm.tiptiles.name || 'NA'}}) : ''
        this.$store.commit('SET_PRODUCT_INFO', data.prm && data.prm.tiptiles ? 'tiptile-' + data.prm.tiptiles.id : data.prm.id)
        Vue.ls.set('listing-scroll-pos', scrollObj)
      },
      encodeFilters (filters) {
        let encodedString = ''
        let sep = ''
        for (let key in filters) {
          if (key === 'sort' || key === 'gender') {
            encodedString += `${sep}${key}||${filters[key]}`
          } else {
            encodedString += `${sep}${key}||${filters[key].join('|')}`
          }
          sep = '|||'
        }
        return encodedString
      },
      decodeFilters (filters) {
        let parsedObj = {}
        for (let row of filters.split('|||')) {
          let d = row.split('||')
          if (d[0] === 'sort' || d[0] === 'gender' || d[0] === 'stock') {
            parsedObj[d[0]] = d[1]
          } else {
            parsedObj[d[0]] = d[1].split('|')
          }
        }
        return parsedObj
      },
      clearFilters () {
        this.query.filters = {sort: this.defaultSort}
        this.clearFilter = true
        this.$router.push({query: {}})
        this.closeFilterModal()
      },
      filterListing () {
        this.query.filters = this.$refs.filterOptions.selectedFilters
        if (this.$route.query.filters === this.encodeFilters(this.query.filters)) {
          return
        }
        this.query.page = this.$route.query.page = 1
        this.mobileCurrentPage = 1
        this.mobileProductsList = []
        this.$router.push({query: Object.assign({}, this.$route.query, {filters: this.encodeFilters(this.query.filters)})})
        this.scrollTillBanner()
        this.closeFilterModal()
        let filterDataCategory = new Set()
        let filterDataSubCategory = new Set()
        this.$refs.filterOptions.getSelectedFilterChips.forEach(item => {
          filterDataCategory.add(item.alias)
          filterDataSubCategory.add(item.name)
        })
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'FILTER_APPLY',
          payload: { GV_INTERACTION_TYPE: 'Preview',
            LIST_NAME: this.formattedHeader,
            APPLIED_FILTERS_CATEGORY: Array.from(filterDataCategory).join('|'),
            APPLIED_FILTERS_SUBCATEGORY: Array.from(filterDataSubCategory).join('|'),
            SEARCH_TERM: 'NA'
          }}
        )
      },
      closeFilterModal () {
        $('.filteroptionsModal').removeClass('active')
        $('.plisting').removeClass('disable')
      },
      toggleExclusiveBar () {
        if (Vue.ls.get('exclusive') !== 1) {
          let $exclusiveElement = $('.exclusive-topbar')
          $exclusiveElement.slideDown()
          $exclusiveElement.find('.close').on('click', function () {
            $exclusiveElement.slideUp()
            Vue.ls.set('exclusive', 1, 30 * 60 * 1000)
          })
        }
      },
      addExclusive (item) {
        if (!this.isExclusive) {
          let _this = this
          this.$store.dispatch('UPDATE_CART', {type: 'products', operation: 'set', route: _this.$route.fullPath, data: {prod_id: item, quantity: 1, categories: []}}).then(() => {
            _this.toggleExclusiveBar()
            Vue.toasted.show('Exclusive added to cart', {theme: 'primary', className: 'toasted-customblue', position: 'top-right', duration: 5000})
            this.exclusiveAdded = true
            if (this.$route.path === '/men/t-shirts') {
              _this.$store.commit('GTAG_EVENT', {eventName: 'exc.membership.added.listing.blue.band', payload: {exclusive_tracker: this.$route.path}})
            }
          })
        } else {
          Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
        }
      },
      removeExcFromCart: function (ExcProdid) {
        this.$store.dispatch('UPDATE_CART', {operation: 'delete', name: 'Exclusive', type: 'products', data: {prod_id: ExcProdid}}).then((res) => {})
        this.togglePopup()
        this.exclusiveAdded = false
      },
      togglePopup () {
        this.isNotifyVisible = !this.isNotifyVisible
      },
      addExclusiveToCartFromBand (item) {
        this.$store.commit('GTAG_EVENT', {eventName: 'exclusive_membership_banner', payload: {}})
        if (!this.isExclusive) {
          let _this = this
          this.$store.dispatch('UPDATE_CART', {type: 'products', operation: 'set', route: _this.$route.fullPath, data: {prod_id: item, quantity: 1, categories: []}}).then(() => {
            _this.toggleExclusiveBar()
            this.isNotifyVisible = true
            this.exclusiveAdded = true
            this.$store.commit('MEMBERSHIP_MANUALLY_ADDED', true)
          })
        } else {
          Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
        }
      },
      loadMoreProducts (query, page, type) {
        if (query) {
          this.loading = true
          this.query.page = page
          this.query.limit = this.$parent.isDesktop ? this.PAGE_LIMIT : this.PAGE_LIMIT
          if (this.selectedGenderTab) {
            this.query.filters['gender'] = String(this.selectedGenderTab === 'men' ? 1 : (this.selectedGenderTab === 'women' ? 2 : 3))
          }
          let routeName = this.$route.path
          this.isTopLoading = false
          this.$store.dispatch('FETCH_PRODUCTS', {...this.query, showTipTiles: true, routeName}).then(response => {
            this.loading = false
            this.isTopLoading = true
            if (this.clearFilter) {
              if (response && response.listing) {
                this.$refs.filterOptions.setFilters(response.listing.filters, this.query.filters)
              }
              this.clearFilter = false
            }
            if (response && response.listing) {
              this.pagination = response.listing.pagination
            }
            if (response && response.listing && response.listing.products) {
              this.showNotFound = true
            }
          })
        } else {
          this.emptySearch = true
        }
      },
      loadMorePrevProducts (query, page, type) {
        if (query) {
          this.loading = true
          this.query.page = page
          this.query.limit = this.$parent.isDesktop ? this.PAGE_LIMIT : this.PAGE_LIMIT
          if (this.selectedGenderTab) {
            this.query.filters['gender'] = String(this.selectedGenderTab === 'men' ? 1 : (this.selectedGenderTab === 'women' ? 2 : 3))
          }
          let routeName = this.$route.path
          this.isTopLoading = false
          this.$store.dispatch('FETCH_PRODUCTS', {...this.query, showTipTiles: true, routeName}).then(response => {
            this.loading = false
            this.isTopLoading = true
            this.scrollItem()
            if (this.clearFilter) {
              if (response && response.listing) {
                this.$refs.filterOptions.setFilters(response.listing.filters, this.query.filters)
              }
              this.clearFilter = false
            }
            if (response && response.listing) {
              this.pagination = response.listing.pagination
            }
            if (response && response.listing && response.listing.products) {
              this.showNotFound = true
            }
          })
        } else {
          this.emptySearch = true
        }
      },
      displaySchemaImage () {
        const productCarauselObject = {
          '@context': 'http://schema.org',
          '@type': 'ItemList'
        }
        const itemListElementArray = []
        for (var i = 0; i < this.allProducts.length; i++) {
          if (i === 10) { break }
          if (!this.allProducts[i].tiptiles) {
            const productDetailSchema =
              {
                '@type': 'ListItem',
                'position': i + 1,
                'url': `${window.location.origin}${this.allProducts[i].artist && this.allProducts[i].artist.name === 'Exclusive' ? '/exclusive' : '/product/'}${this.allProducts[i].product_slug}?gte=${this.allProducts[i].genderType || 0}`,
                'name': this.allProducts[i].product,
                'description': `Buy ${this.allProducts[i].product} ${this.allProducts[i].category && this.allProducts[i].category.name} Tshirts From The souled store at Best Price`,
                'image': process.env.IMG_BASE_URL + process.env.PRODUCT_DETAIL_IMG + (this.allProducts[i] && this.allProducts[i].images && this.allProducts[i].images[0])
              }
            itemListElementArray.push(productDetailSchema)
          }
        }
        productCarauselObject.itemListElement = itemListElementArray
        return productCarauselObject
      },
      displaySchemaBreadcrumb () {
        const productCarauselObject = {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList'
        }
        const itemListElement = [{
          '@type': 'ListItem',
          'position': 1,
          'name': 'Home',
          'item': 'https://www.thesouledstore.com'
        }]
        if (this.breadcrumbText) {
          itemListElement.push({
            '@type': 'ListItem',
            'position': 2,
            'name': ' Official-Merch',
            'item': 'https://www.thesouledstore.com/official-merch'
          })
        }
        itemListElement.push({
          '@type': 'ListItem',
          'position': this.breadcrumbText ? 3 : 2,
          'name': this.breadcrumb && this.breadcrumb.replace('\u0099', '')
        })
        productCarauselObject.itemListElement = itemListElement
        return productCarauselObject
      },
      getLandingProducts (dataObj) {
        this.isKids = dataObj && dataObj.isKids
        this.selectedGenderTab = dataObj.gender
        if (this.selectedGenderTab === '') {
          this.deselectedGenderTab = true
        }
        this.getproducts(dataObj, this.$route.query)
      },
      getproducts (params, query) {
        if (this.webcategory) {
          this.profilePhoto = false
          let page = this.mobileCurrentPage
          if (!page) {
            page = 1
          }
          let listingData = {
            pageContent: {},
            itemList: {}
          }
          this.$set(this.$parent, 'loading', true)
          let metaPayload = ''
          if (this.$route.params.type) {
            metaPayload = {type: this.$route.params.type, slug: this.$route.params.sid}
          } else {
            metaPayload = {type: 'tags', slug: this.$route.params.sid}
          }
          this.isArtistListing = false
          this.notFound = false
          this.emptySearch = false
          this.$store.dispatch('GET_LISTING_META', metaPayload).then(async (response) => {
            this.loading = true
            this.metaTitle = response.data.meta_title
            this.ogTitle = response.data.og_title
            this.ogDescription = response.data.og_description
            this.metaUrl = 'www.thesouledstore.com' + this.$route.path + '/'
            this.metaTwitterTitle = response.data.twitter_title
            this.metaTwitterDescription = response.data.twitter_description
            this.metaDescription = response.data.meta_desc
            this.metaKeywords = response.data.meta_keys
            this.bannerPromotionName = response.data.promotion_name
            this.bannerId = response.data.id
            this.profilePic = ''
            let mobileBanners = []
            let desktopBanners = []
            let payload = {filters: {}}
            let gender = this.webcategory
            if (this.selectedGenderTab) {
              gender = this.selectedGenderTab
              this.query.page = this.$route.query.page = 1
              this.mobileCurrentPage = 1
              this.mobileProductsList = []
              page = 1
            } else if (this.deselectedGenderTab) {
              gender = this.webcategory
              this.query.page = this.$route.query.page = 1
              this.mobileCurrentPage = 1
              this.mobileProductsList = []
              page = 1
            }
            payload['gender'] = gender === 'men' ? 1 : (gender === 'women' ? 2 : 0)
            payload.isKids = this.webcategory === 'kids'
            if (params.isKids) {
              payload.isKids = params.isKids
            }
            listingData.pageContent = response.data
            if (metaPayload.type === 'explore' || metaPayload.type === 'men' || metaPayload.type === 'women' || metaPayload.type === 'kids') {
              if (response.data.catBanner.length) {
                let navObj = response.data.catBanner.find(item => item.type === '1')
                mobileBanners = response.data.catBanner.filter(item => item.type === '1').map(item => this.catImgPath + item.mobile_image)
                desktopBanners = response.data.catBanner.filter(item => item.type === '1').map(item => this.catImgPath + item.filename)
                this.navLink = navObj && navObj.navigation_link
              } else {
                mobileBanners = []
                desktopBanners = []
              }
              payload['category'] = [response.data.id]
              payload['category_merge'] = [...new Set([response.data.id, ...(response.data.category_merge || [])])]
              this.breadcrumb = response.data.breadcrum_name
              this.breadcrumbUrl = this.$route.path === '/men/winter-wear' || this.$route.path === '/women/winter-wear' ? '/winterwear-collection' : ''
              this.breadcrumbText = this.$route.path === '/men/winter-wear' || this.$route.path === '/women/winter-wear' ? 'Winter-Collection' : ''
              this.headingTitle = response.data.breadcrum_title
              this.defaultSort = 'DEFAULT'
              this.listingBannerAlt = `${response.data.category} Online`
              listingData.pageContent = response.data
            } else if (metaPayload.type === 'artists') {
              payload['artist'] = [metaPayload.slug]
              this.breadcrumb = response.data.breadcrum_name
              this.breadcrumbUrl = '/official-merch'
              this.breadcrumbText = 'Official-Merch'
              this.headingTitle = response.data.breadcrum_title
              this.defaultSort = 'POPULARITY'
              this.listingBannerAlt = `Official Merchandise of ${response.data.firstname} Online`
              this.artistData = response.data
              this.navLink = response.data && response.data.navigation_link
              mobileBanners = []
              if (response.data.mobile_cover_pic.length) {
                mobileBanners = [this.artistImgPath + response.data.mobile_cover_pic]
              }
              if (this.webcategory === 'kids' && (response.data && response.data.kids_mob_cover_pic !== '[]')) {
                mobileBanners = [this.artistImgPath + (response.data && response.data.kids_mob_cover_pic)]
              }
              desktopBanners = []
              if (response.data.cover_pic.length) {
                desktopBanners = [this.artistImgPath + response.data.cover_pic]
              }
              if (this.webcategory === 'kids' && (response.data && response.data.kids_cover_pic !== '[]')) {
                desktopBanners = [this.artistImgPath + (response.data && response.data.kids_cover_pic)]
              }
              this.profilePic = this.artistImgPath + response.data.profile_pic
              if (response.data.profile_pic.length > 0) {
                this.profilePhoto = true
              }
              listingData.pageContent = response.data
            } else if (metaPayload.type === 'tags') {
              payload['tags'] = [metaPayload.slug]
              this.breadcrumb = response.data.breadcrum_name
              this.breadcrumbUrl = '/official-merch'
              this.breadcrumbText = 'Official-Merch'
              this.headingTitle = response.data.breadcrum_title
              this.defaultSort = 'POPULARITY'
              this.navLink = response.data && response.data.navigation_link
              this.listingBannerAlt = `${response.data.name} Merchandise Online`
              mobileBanners = []
              if (response.data.mobile_banners && response.data.mobile_banners.length) {
                mobileBanners = [this.tagImgPath + response.data.mobile_banners]
              }
              if (this.webcategory === 'kids' && (response.data && response.data.kids_mob_banner)) {
                mobileBanners = [this.tagImgPath + (response.data && response.data.kids_mob_banner)]
              }
              desktopBanners = []
              if (response.data.banners && response.data.banners.length) {
                desktopBanners = [this.tagImgPath + response.data.banners]
              }
              if (this.webcategory === 'kids' && (response.data && response.data.kids_banner)) {
                desktopBanners = [this.tagImgPath + (response.data && response.data.kids_banner)]
              }
              listingData.pageContent = response.data
            }
            payload['page'] = page
            payload['limit'] = this.$parent.isDesktop ? this.PAGE_LIMIT : this.PAGE_LIMIT
            payload.filters['sort'] = this.defaultSort
            if (this.selectedGenderTab) {
              payload.filters['gender'] = String(this.selectedGenderTab === 'men' ? 1 : (this.selectedGenderTab === 'women' ? 2 : 3))
            }
            this.query = payload
            this.banners = {mobile: mobileBanners, desktop: desktopBanners}
            this.handleMinHeight()
            this.bannersVedio = {
              show_video_url: response.data.show_video_url,
              video_thumbnail: response.data.video_thumbnail,
              mobile_video_thumbnail: response.data.mobile_video_thumbnail,
              video_url: response.data.video_url,
              mobile_video_url: response.data.mobile_video_url,
              video_url_index: response.data.video_url_index
            }
            let filterCopy = JSON.parse(JSON.stringify(this.query_filters))
            if (this.$refs && this.$refs.filterOptions && this.$refs.filterOptions.selectedFilters && this.$refs.filterOptions.selectedSortObj.sort === 'DEFAULT') {
              this.$refs.filterOptions.selectedFilters = {sort: 'DEFAULT', gender: 0, stock: ''}
              this.$refs.filterOptions.selectedSortObj = {sort: 'DEFAULT', gender: 0, stock: ''}
            }
            if (this.query_filters) {
              this.$refs.filterOptions.selectedSortObj.sort = filterCopy.sort
              payload.filters = filterCopy
              this.query_filters = null
            } else {
              this.$refs.filterOptions.selectedSortObj.sort = 'DEFAULT'
            }
            const plpCache = await indexedDb.get('plpCache')
            if (plpCache && Vue.ls.get('listCache_header') === document.URL && !this.loading) {
              this.$store.commit('SET_PRODUCTS', plpCache)
              if (!this.query_filters) {
                this.emptySearch = true
              }
              this.sneakerdata = payload.filters.sneaker
              this.$refs.filterOptions.setFilters(plpCache.filters, payload.filters)
              const cachedPagination = plpCache.pagination
              this.pagination = cachedPagination
              this.mobileCurrentPage = cachedPagination && cachedPagination.currentPage
              if (Vue.ls.get('genderTabsCache')) {
                this.tabsCountData[0].is_men = Vue.ls.get('genderTabsCache') && Vue.ls.get('genderTabsCache').is_men
                this.tabsCountData[0].is_women = Vue.ls.get('genderTabsCache') && Vue.ls.get('genderTabsCache').is_women
                this.tabsCountData[0].is_kids = Vue.ls.get('genderTabsCache') && Vue.ls.get('genderTabsCache').is_kids
              }
              this.loading = false
              const cachedProducts = plpCache.products
              let fbData = {data: cachedProducts, route: this.$route.params.sid}
              this.$store.commit('GTAG_EVENT', {eventName: 'FB_View_Listing',
                payload: {
                  fbData: cachedProducts,
                  route: this.$route.params.sid
                }}
              )
              this.$store.commit('GTAG_EVENT', {eventName: 'crto_listingpage',
                payload: {
                  crto: {
                    email: this.user && this.user.email,
                    listing_products: cachedProducts && cachedProducts
                  }
                }}
              )
              listingData.itemList = fbData
            } else {
              let routeName = this.$route.path
              let chachedGender = 0
              if (this.isShowAutoSelectedGenderSwitch) {
                let gender = Vue.ls.get('tss_landingCategory')
                if (gender === 'men') {
                  chachedGender = 1
                } else if (gender === 'women') {
                  chachedGender = 2
                } else if (gender === 'kids') {
                  chachedGender = 3
                }
              }
              let agegroup = []
              if (this.navigatedFromAgeGroup && this.navigatedFromAgeGroup.length && this.isAutoAppliedFilter) {
                agegroup = this.navigatedFromAgeGroup[0] + ',' + this.navigatedFromAgeGroup[1]
              }
              const isFirstCall = Vue.ls.get('is_first_call')
              if (isFirstCall) {
                let scrollObj = Vue.ls.get('listing-scroll-pos')
                if (scrollObj && scrollObj['loadOnce']) {
                  payload['page'] = scrollObj['pageNo']
                  this.mobileCurrentPage = scrollObj['pageNo']
                  this.onLoadFirstSrollPage = scrollObj['pageNo']
                  this.onLoadFirstPage = scrollObj['pageNo']
                  scrollObj['loadOnce'] = false
                  Vue.ls.set('listing-scroll-pos', scrollObj)
                }
                Vue.ls.set('is_first_call', false)
              }
              this.$store.dispatch('FETCH_PRODUCTS', { ...payload, showTipTiles: true, routeName, chachedGender, agegroup }).then(response => {
                if (!this.query_filters) {
                  this.emptySearch = true
                }
                if (response && response.listing) {
                  if (!this.$parent.isDesktop) {
                    this.getGenderTabsdata(this.urlSlug, this.pageType, response.listing)
                  }
                  this.sneakerdata = payload.filters.sneaker
                  this.$refs.filterOptions.setFilters(response.listing.filters, payload.filters)
                  this.pagination = response.listing.pagination
                }
                this.loading = false
                // if (response.listing && response.listing.products && !response.listing.products.length) {
                //   this.notFound = true
                // } else {
                //   this.notFound = false
                // }
                let fbData = {data: this.allProducts, route: this.$route.params.sid}
                this.$store.commit('GTAG_EVENT', {eventName: 'FB_View_Listing',
                  payload: {
                    fbData: this.allProducts,
                    route: this.$route.params.sid
                  }}
                )
                this.$store.commit('GTAG_EVENT', {eventName: 'crto_listingpage',
                  payload: {
                    crto: {
                      email: this.user && this.user.email,
                      listing_products: this.allProducts && this.allProducts
                    }
                  }}
                )
                listingData.itemList = fbData
                Vue.ls.set('listCache_header', document.URL)
              })
            }
            this.$store.dispatch('GET_PLP_TIMER', {
              category: payload.category || [],
              artist: payload.artist || [],
              tags: payload.tags || []
            })
            if (payload) {
              const eventPayload = {
                parent_event_name: 'general_event',
                event_name: 'plp',
                url: `https://www.thesouledstore.com${this.$router.currentRoute && this.$router.currentRoute.path}`,
                categories: [payload.category_merge && payload.category_merge.join(',')],
                artists: [payload.artist && payload.artist[0]],
                themes: [payload.tags && payload.tags[0]]
              }
              this.$store.dispatch('TRACK_STORE_EVENT', eventPayload)
              this.$store.commit('MOENGAGE_EVENT', {eventName: 'PLP_USER_HISTORY', payload: eventPayload})
            }
          }).catch(err => {
            this.notFound = true
            this.setMinHeight = false
            console.error(err)
          })
        }
      },
      activateLightTheme () {
        this.theme = 'light-mode'
        document.body.classList.add('light-mode')
        document.body.classList.remove('dark-mode')
      },
      activateDarkTheme () {
        this.theme = 'dark-mode'
        document.body.classList.remove('light-mode')
        document.body.classList.add('dark-mode')
      },
      checkForStarWarPage () {
        const path = this.$route.path
        if (path === '/artists/starwars-official-merchandise') {
          if (this.theme === 'light-mode') {
            document.body.classList.add('light-mode')
            document.body.classList.remove('dark-mode')
          } else {
            document.body.classList.remove('light-mode')
            document.body.classList.add('dark-mode')
          }
        } else {
          document.body.classList.remove('light-mode', 'dark-mode')
        }
      },
      giftVoucherRedirect () {
        this.$router.push('/gift-voucher')
      },
      twoArrayIsSame: function (arr1, arr2) {
        let fCounter1 = {}
        let fCounter2 = {}
        if (arr1.length !== arr2.length) return false
        for (let f1 of arr1) {
          fCounter1[f1] = (fCounter1[f1] || 0) + 1
        }
        for (let f2 of arr2) {
          fCounter2[f2] = (fCounter2[f2] || 0) + 1
        }
        for (let key in fCounter1) {
          if (!(key in fCounter2)) return false
        }
        return true
      },
      /* timer logic starts here */
      getSaleTextToShow () {
        let saleDetails = this.saleDet
        let excStartDate = this.$parent.formatDateSale(saleDetails.show_exclusive_date_time)
        let excEndDate = this.$parent.formatDateSale(saleDetails.show_exclusive_end_date_time)
        let nonExcStartDate = this.$parent.formatDateSale(saleDetails.show_start_date_time)
        let nonExcEndDate = this.$parent.formatDateSale(saleDetails.show_end_date_time)
        this.now = this.formatTime()
        if ((this.exclusiveUser || this.isExclusive) && saleDetails.early_access) {
          if (moment(this.now) >= moment(excStartDate) && moment(this.now) < moment(excEndDate)) {
            if (saleDetails.early_access) this.timerData.liveSaleText = saleDetails.pre_early_access_text
            else this.timerData.liveSaleText = saleDetails.pre_live_sale_text
            // show timer
            if (!this.timerData.showCountDown) this.timerData.showCountDown = true
            // show blur
            this.timerData = {
              ...this.timerData,
              showBlur: saleDetails.enable_blur
            }
            // hide wishlist
            this.hideWishlist = true
            return saleDetails.pre_early_access_text
          } else if (moment(this.now) >= moment(nonExcStartDate) && moment(this.now) < moment(nonExcEndDate)) {
            if (this.timerData.liveSaleText !== saleDetails.early_access_text) this.timerData.liveSaleText = saleDetails.early_access_text
            this.timerData.showEarlyText = true
            // show timer
            if (!this.timerData.showCountDown) this.timerData.showCountDown = true
            // hide blur
            this.timerData = {
              ...this.timerData,
              showBlur: false
            }
            // show wishlist
            this.hideWishlist = false
            return
          }
          // show timer
          if (this.timerData.showTimer) this.timerData.showTimer = false
          if (this.timerData.showCountDown) this.timerData.showCountDown = false
          // hide blur
          this.timerData = {
            ...this.timerData,
            showBlur: false
          }
          // show wishlist
          this.hideWishlist = false
        } else {
          if (moment(this.now) >= moment(nonExcStartDate) && moment(this.now) < moment(nonExcEndDate)) {
            if (this.timerData.liveSaleText !== saleDetails.pre_live_sale_text) this.timerData.liveSaleText = saleDetails.pre_live_sale_text
            // show timer
            if (!this.timerData.showCountDown) this.timerData.showCountDown = true
            // show blur
            this.timerData = {
              ...this.timerData,
              showBlur: saleDetails.enable_blur
            }
            // hide wishlist
            this.hideWishlist = true
            return
          }
          // show timer
          if (this.timerData.showTimer) this.timerData.showTimer = false
          if (this.timerData.showCountDown) this.timerData.showCountDown = false
          // hide blur
          this.timerData = {
            ...this.timerData,
            showBlur: false
          }
          // show wishlist
          this.hideWishlist = false
        }
      },
      saleBanner: function (saleDetails) {
        this.now = this.formatTime()
        if (saleDetails && Object.keys(saleDetails).length) {
          this.saleDet = saleDetails
          this.timerData.showTimer = saleDetails.timer_status
          if (saleDetails.add_cart_status_web) {
            // need to add logic for disabling the add to cart button
          } else {
            // need to add logic for change cart text & its color
          }
          // early access true & user is exclusive
          if (saleDetails.early_access && (this.exclusiveUser || this.isExclusive)) {
            const exclusiveDate = this.$parent.formatDateSale(saleDetails.show_exclusive_date_time)
            const startDate = this.$parent.formatDateSale(saleDetails.show_exclusive_date_time)
            const endDate = this.$parent.formatDateSale(saleDetails.show_exclusive_end_date_time)
            this.timerData = {
              ...this.timerData,
              startDate: startDate && new Date(startDate),
              endDate: endDate && new Date(endDate),
              exclusiveDate
            }
          } else {
            const startDate = this.$parent.formatDateSale(saleDetails.show_start_date_time)
            const endDate = this.$parent.formatDateSale(saleDetails.show_end_date_time)
            this.timerData = {
              ...this.timerData,
              startDate: startDate && new Date(startDate),
              endDate: endDate && new Date(endDate)
            }
          }
        }
        this.getSaleTextToShow()
        this.timerCount()
        this.timerInterval = setInterval(() => {
          this.getSaleTextToShow()
          this.timerCount()
        }, 1000)
      },
      timerCount: function () {
        const now = new Date()
        this.timerData = {
          ...this.timerData,
          now
        }
        let timeLapsed = this.timerData.startDate - now
        let timeRemaining = this.timerData.endDate - now
        if (timeRemaining < 0) {
          clearInterval(this.timerInterval)
          return
        } else if (timeLapsed < 0 && timeRemaining > 0) {
          this.computeTime(timeRemaining)
        }
      },
      computeTime: function (time) {
        const days = Math.floor(time / (1000 * 60 * 60 * 24))
        const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((time % (1000 * 60)) / 1000)
        this.timerData = {
          ...this.timerData,
          days,
          hours,
          minutes,
          seconds
        }
      },
      /* timer logic ends here */
      removeFilterChipHandler (item) {
        this.$refs.filterOptions.removeFilterChipHandler(item)
      },
      getBannerImpressionData (index) {
        return {
          promotion_id: this.bannerId || '',
          promotion_name: this.bannerPromotionName || '',
          creative_name: this.listingBannerAlt || '',
          creative_slot: index,
          currency: 'INR'
        }
      },
      bannerClick (index) {
        const payload = this.getBannerImpressionData(index)
        this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'select_promotion',
          payload: {
            creative_name: payload.creative_name ? payload.creative_name : 'NA',
            creative_slot: payload.creative_slot || payload.creative_slot === 0 ? payload.creative_slot : 'NA',
            promotion_id: payload.promotion_id ? payload.promotion_id : 'NA',
            promotion_name: payload.promotion_name ? payload.promotion_name : 'NA'
          }
        })
      },
      anyTwoGenderKeysTrue () {
        const object = this.tabsCountData[0]
        const keys = Object.keys(object)
        for (let i = 0; i < keys.length - 1; i++) {
          for (let j = i + 1; j < keys.length; j++) {
            if (object[keys[i]] && object[keys[j]] && this.webcategory !== 'kids') {
              return true
            } else if (!object[keys[i]] && !object[keys[j]] && object.is_kids && this.isShowBoyGirlTab) {
              return true
            }
          }
        }
        return false
      },
      getGenderTabsdata (urlSlug, pageType, responseListing) {
        const params = {
          url_slug: urlSlug,
          page_type: pageType
        }
        this.$store.dispatch('GET_PLP_GENDER_TABS_DATA', {params}).then(response => {
          if (response && Object.keys(response).length) {
            this.tabsCountData[0].is_kids = response.is_kids
            this.tabsCountData[0].is_men = response.is_men
            this.tabsCountData[0].is_women = response.is_women
          } else {
            this.tabsCountData[0].is_kids = responseListing.is_kid_data_available
            this.tabsCountData[0].is_men = responseListing.is_male_data_available
            this.tabsCountData[0].is_women = responseListing.is_female_data_available
          }
          Vue.ls.set('genderTabsCache', {'is_kids': this.tabsCountData[0].is_kids, 'is_men': this.tabsCountData[0].is_men, 'is_women': this.tabsCountData[0].is_women})
        })
      },
      scrollTillBanner: function () {
        const element = document.querySelector('.main-banner-area')
        if (element) {
          const height = element.clientHeight
          window.scrollTo({
            top: height,
            left: 0,
            behavior: 'smooth'
          })
        }
      }
    },
    mounted: function () {
      this.handleMinHeight()
      if (!this.isExclusive && !this.exclusiveUser) {
        this.$store.dispatch('GET_EXC_MEM_DATA_FROM_CMS')
      }
      this.plpFirstVisit = this.getFromSessionStorage('plp_first_visit')
      this.listingUrl = this.$route.path
      this.$store.dispatch('SET_DEFAULT_BUSY')
      Vue.ls.remove('listCache_header_updator')
      this.checkForStarWarPage()
      this.canonicalUrl = parseInt(this.$route.query.page || 1) !== 1
      ? window.location.href.split('?')[0] + '?page=' + (this.$route.query.page || 1)
      : window.location.href.split('?')[0]
      this.nextUrl = (parseInt(this.$route.query.page || 1) + 1) !== 1
      ? window.location.href.split('?')[0] + '?page=' + (parseInt(this.$route.query.page || 1) + 1)
      : window.location.href.split('?')[0]
      this.prevUrl = (parseInt(this.$route.query.page || 1) - 1) !== 1
      ? window.location.href.split('?')[0] + '?page=' + (parseInt(this.$route.query.page || 1) - 1)
      : window.location.href.split('?')[0]
      if (!this.$parent.isDesktop) {
        this.$store.commit('SET_FOOTER_COLLAPSE_CONTROL', {
          expanded: true,
          expandedClass: 'show', // '' or show
          bottomStyle: 'margin-bottom: 45px;'
        })
      }
      this.$store.commit('SET_LISTING_LANDING_DATE', new Date())
      window.addEventListener('beforeunload', () => {
        if (this.plpFirstVisit) {
          this.saveToSessionStorage('plp_first_visit', false)
        }
      })
      this.$store.commit('GTAG_EVENT', {eventName: 'page_view',
        payload: {
          sendTo: process.env.GOOGLE_ADWORDS_ID,
          ecomm_pagetype: this.listingType,
          page_title: 'plp_page'
        }}
      )
      this.observerBottom = new IntersectionObserver(entries => {
        const entry = entries[0]
        if (entry.isIntersecting && this.pagination && this.mobileCurrentPage < this.pagination.totalPages) {
          const currentPage = this.mobileCurrentPage + 1
          this.mobileCurrentPage = currentPage
          this.loadMoreProducts(this.query, currentPage)
        }
      })
      if (this.$refs.scrollSentinelBottom) {
        this.observerBottom.observe(this.$refs.scrollSentinelBottom)
      }
      this.observerTop = new IntersectionObserver(entries => {
        const entry = entries[0]
        if (entry.isIntersecting) {
          this.isScrollToUpVisible = false
          if (entry.isIntersecting && this.pagination && this.onLoadFirstSrollPage > 1) {
            if (this.isTopLoading) {
              const currentPage = this.onLoadFirstSrollPage - 1
              this.onLoadFirstSrollPage = currentPage
              let scrollInfo = Vue.ls.get('listing-scroll-pos')
              if (scrollInfo) {
                scrollInfo.performScroll = true
                Vue.ls.set('listing-scroll-pos', scrollInfo)
              }
              this.loadMorePrevProducts(this.query, currentPage)
            }
          }
        } else {
          this.isScrollToUpVisible = true
        }
      })
      if (this.$refs.scrollSentinelTop) {
        this.observerTop.observe(this.$refs.scrollSentinelTop)
      }
    },
    watch: {
      '$route' (to, from) {
        this.saveToSessionStorage('plp_first_visit', false)
        this.plpFirstVisit = this.getFromSessionStorage('plp_first_visit')
        if (to.query && !to.query.filters) {
          this.query.filters = {sort: this.defaultSort}
          this.clearFilter = true
          this.closeFilterModal()
        }
        this.canonicalUrl = parseInt(this.$route.query.page || 1) !== 1
      ? window.location.href.split('?')[0] + '?page=' + (this.$route.query.page || 1)
      : window.location.href.split('?')[0]
        this.nextUrl = (parseInt(this.$route.query.page || 1) + 1) !== 1
      ? window.location.href.split('?')[0] + '?page=' + (parseInt(this.$route.query.page || 1) + 1)
      : window.location.href.split('?')[0]
        this.prevUrl = (parseInt(this.$route.query.page || 1) - 1) !== 1
      ? window.location.href.split('?')[0] + '?page=' + (parseInt(this.$route.query.page || 1) - 1)
      : window.location.href.split('?')[0]
        Vue.ls.set('listCache_header_updator', document.URL)
        this.mobileCurrentPage = 1
        this.$store.commit('EC_PLP_PROD_VIEW_RESET')
        this.$store.commit('MOENGAGE_PLP_PROD_VIEW_RESET')
        this.productCategory = to.params.sid
        if (this.$route.query.filters) {
          this.query_filters = this.decodeFilters(this.$route.query.filters)
        } else {
          this.query_filters = null
        }
        if (to.params.sid === from.params.sid && to.params.type === from.params.type) {
          if (to.query.page) {
            this.loadMoreProducts(this.query, to.query.page)
          } else {
            this.loadMoreProducts(this.query, 1)
          }
        } else {
          this.mobileProductsList = []
          this.getproducts(to.params, to.query)
        }
        this.checkForStarWarPage()
      },
      'active_pricelists' () {
        if (!this.twoArrayIsSame((this.oldActivePricelists && this.oldActivePricelists.pricelists) || [], this.active_pricelists.pricelists || [])) {
          this.loadMoreProducts(this.query, this.query.page)
        }
      },
      plpTimer (value) {
        if (value && Object.keys(value).length) {
          this.saleBanner(value)
        } else {
          this.saleDet = {}
        }
      },
      webcategory (value) {
        if (value) {
          Vue.ls.set('listCache_header', '')
          this.getproducts(this.$route.params, this.$route.query)
        }
      },
      async allProducts (productsList) {
        if (this.onLoadFirstPage === 1 && this.currentPage === 1) {
          this.mobileProductsList = [...productsList]
        } else {
          let newList
          if (this.onLoadFirstPage > this.currentPage) {
            newList = [...productsList, ...this.mobileProductsList]
          } else {
            newList = [...this.mobileProductsList, ...productsList]
          }
          this.mobileProductsList = newList && [...newList]
          try {
            const existingCache = await indexedDb.get('plpCache') || {}
            await indexedDb.set('plpCache', {
              ...existingCache,
              products: newList
            })
          } catch (error) {
            console.error('Failed to cache PLP data:', error)
          }
        }
        if (productsList.length) {
          const productListing = [...productsList]
          productListing.forEach(item => {
            this.$store.commit('MOENGAGE_EVENT', {
              eventName: 'PLP-ALL-LISTS',
              payload: {
                Product_ID: item.id,
                ProductImage_URL: `${process.env.IMG_BASE_URL}${process.env.PRODUCT_IMG}${item && item.images && item.images[0]}`,
                isUserLoggedIn: this.authStatus ? this.authStatus : false
              }
            })
          })
        }
      },
      formattedHeader () {
        this.$store.commit('SET_PRODUCT_LISTING_HEADER', {header: this.formattedHeader})
      },
      hasAddressChanged: {
        handler: function () {
          Vue.ls.set('listing_meta_info', null)
          Vue.ls.set('listCache_header', '')
          this.getproducts(this.$route.params, this.$route.query)
        },
        deep: true
      }
    },
    created: function () {
      this.animationStorageHandler()
      Vue.ls.set('pdp_checkDrop', false)
      Vue.ls.set('is_first_call', true)
      this.$store.commit('SET_PRODUCT_LISTING_HEADER', {})
      if (this.$route.params.sid === undefined && this.$route.params.type !== 'tags' && this.$route.params.sid !== 'tags') {
        if (this.selectedTags.includes(this.$route.params.type)) {
          this.$router.replace('/tags/' + this.$route.params.type)
          this.$route.params.type = 'tags'
        } else {
          this.productCategory = this.$route.params.sid
          this.$route.params.type = 'tags'
        }
      } else {
        if (this.$route.params.type === 'tags' && !this.selectedTags.includes(this.$route.params.sid)) {
          this.productCategory = this.$route.params.sid
          this.$route.params.type = 'tags'
        }
        this.productCategory = this.$route.params.sid
      }
      this.$store.commit('GTAG_EVENT', {eventName: 'ct_page_viewed_custom', payload: {pdp_response: {category: this.productCategory, routeObj: (Vue.ls.get('routeObj')).current}}})
      this.$store.commit('GTAG_EVENT', {eventName: 'Page_Viewed', payload: {pdp_response: {category: this.productCategory, routeObj: (Vue.ls.get('routeObj')).current}}})
      this.referrerUrl = this.$route.path
      this.$store.dispatch('SET_DEFAULT_CATALOG')
      this.$store.dispatch('SET_DEFAULT_BUSY')
      if (this.$route.query.filters) {
        this.query_filters = this.decodeFilters(this.$route.query.filters)
      }
      if (this.$route.params.type === undefined) {
        this.$route.params.type = 'tags'
      }
      Vue.ls.set('listCache_header', '')
      this.getproducts(this.$route.params, this.$route.query)
      if (Vue.ls.get('listCacheMockupTag')) {
        this.$store.commit('SET_PLP_MOCKUP_TAGS', Vue.ls.get('listCacheMockupTag'))
      }
      this.$store.dispatch('GET_PLP_MOCK_TAG')
    },
    updated: function () {
      let scrollInfo = Vue.ls.get('listing-scroll-pos')
      if (scrollInfo && scrollInfo.performScroll) {
        this.scrollNow()
      }
      if (this.$refs.scrollSentinelBottom && this.observerBottom) {
        this.observerBottom.observe(this.$refs.scrollSentinelBottom)
      }
      if (this.$refs.scrollSentinelTop && this.observerTop) {
        this.observerTop.observe(this.$refs.scrollSentinelTop)
      }
    },
    beforeDestroy () {
      if (this.observerBottom) {
        this.observerBottom.disconnect()
      }
      if (this.observerTop) {
        this.observerTop.disconnect()
      }
      this.saveToSessionStorage('plp_first_visit', false)
      this.plpFirstVisit = this.getFromSessionStorage('plp_first_visit')
      clearInterval(this.timerInterval)
      if (this.tatvicProductImpression && this.tatvicProductImpression.data.length) {
        this.$store.commit('EC_PLP_PROD_VIEW_RESET')
      }
      if (this.moengageImpressionData && Object.keys(this.moengageImpressionData).length) {
        this.$store.commit('MOENGAGE_EVENT', {
          eventName: 'view_product_list',
          payload: {
            ...this.moengageImpressionData
          }
        })
        this.$store.commit('MOENGAGE_PLP_PROD_VIEW_RESET')
      }
      this.$store.commit('SET_LISTING_LANDING_DATE', '')
      Vue.ls.get('listCache_header_updator') ? Vue.ls.set('listCache_header', Vue.ls.get('listCache_header_updator')) : ''
      Vue.ls.remove('pdp_checkDrop')
    },
    computed: {
      ...mapState({listbox: state => state.product.listbox, metadata: state => state.product.metadata}),
      ...mapGetters(['category', 'busy', 'isExclusive', 'active_pricelists', 'oldActivePricelists', 'site_config', 'exclusiveUser', 'calculations', 'productId', 'plpTimer', 'plpMockUpTags', 'bannerPlcaeHolderData', 'dailyDropObj', 'wishlistItemsIDs', 'authStatus', 'webcategory', 'allProducts', 'webpushInitiator', 'tatvicProductImpression', 'user', 'get_exclusive_user', 'moengageImpressionData', 'isSelectedCountryIndia', 'hasAddressChanged', 'navigatedFromAgeGroup', 'currentPage']),
      formattedArtist: function () {
        if (!this.breadcrumb) {
          return
        }
        return this.breadcrumb.replace('\u0099', '&trade;')
      },
      isBannerAvailable () {
        return this.banners.desktop.length > 0 && this.banners.mobile.length > 0
      },
      displayProductCount: function () {
        // If we are on the last page (or beyond), the number of loaded products
        // should be clamped to the total number of products.
        if (this.pagination && this.mobileCurrentPage >= this.pagination.totalPages) {
          return this.pagination.totalProduct
        }
        // Otherwise, just show the current length of the list.
        return this.productsListing.length
      },
      productsListing: function () {
        return this.mobileProductsList
      },
      formattedArtistName: function () {
        if (!this.allProducts || this.$route.path.split('/')[1] === 'men' || this.$route.path.split('/')[1] === 'women' || this.$route.path.split('/')[1] === 'artists' || this.$route.path.split('/')[1] === 'tags') {
          return
        }
        if (this.allProducts && this.allProducts.length > 0) {
          var slg = this.$route.path.split('/')[1]
          var arslg = this.allProducts[0]['artist'] && this.allProducts[0]['artist']['slug']
          if (arslg && arslg.indexOf(slg.split('-')[0]) !== -1) {
            return this.allProducts[0]['artist'] && this.allProducts[0]['artist']['name'].replace('\u0099', '&trade;')
          }
          if (this.allProducts.length > 1 && this.allProducts[0]['artist'] && this.allProducts[1]['artist'] && this.allProducts[0]['artist']['slug'] === this.allProducts[1]['artist']['slug']) {
            return this.allProducts[0]['artist']['name'].replace('\u0099', '&trade;')
          }
        }
        if (this.allProducts && this.allProducts.length === 1) {
          return this.allProducts[0]['artist'] && this.allProducts[0]['artist']['name'].replace('\u0099', '&trade;')
        }
      },
      formattedArtistSlug: function () {
        if (!this.allProducts) {
          return
        }
        return '/artists/' + this.allProducts[0]['artist']['slug'].replace('\u0099', '&trade;')
      },
      formattedHeader: function () {
        if (!this.headingTitle) {
          return
        }
        return this.headingTitle.replace('\u0099', '&trade;')
      },
      EXCLUSIVE_PRODUCTS: function () {
        return this.site_config.exclusive_products
      },
      bannerPLPRating: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_RATING_ON_PLP_WEB'.toLowerCase())
      },
      isAutoAppliedFilter: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'AUTO_FILTER_APPLIED_PLP_WEB'.toLowerCase())
      },
      bannerPlaceHolderForExclusive: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let PLPExcBannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
            bannerData.product_type.toLowerCase() === 'Exclusive_Blue_Band_Web'.toLowerCase())
          if (PLPExcBannerObj && Object.keys(PLPExcBannerObj).length) {
            let PLPExcBannerPhObj = {}
            PLPExcBannerPhObj.styles = {
              backgroundColor: PLPExcBannerObj.banner_color,
              color: PLPExcBannerObj.banner_text_color
            }
            PLPExcBannerPhObj.text = PLPExcBannerObj.tag_text
            PLPExcBannerPhObj.status = PLPExcBannerObj.status
            return PLPExcBannerPhObj
          }
        }
      },
      bannerPlaceHolderForExc: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let PLPExcBannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'PLP_EXCLUSIVE_WEB'.toLowerCase())
          if (PLPExcBannerObj && Object.keys(PLPExcBannerObj).length) {
            let PLPExcBannerPhObj = {}
            PLPExcBannerPhObj.styles = {
              backgroundColor: PLPExcBannerObj.banner_color,
              color: PLPExcBannerObj.banner_text_color
            }
            PLPExcBannerPhObj.text = PLPExcBannerObj.tag_text
            PLPExcBannerPhObj.status = PLPExcBannerObj.status
            return PLPExcBannerPhObj
          }
        }
      },
      bannerPlaceHolderForNonExc: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let PLPNonExcBannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'PLP Non-Exclusive'.toLowerCase() && bannerData.status === true)
          if (PLPNonExcBannerObj && Object.keys(PLPNonExcBannerObj).length) {
            let PLPNonExcBannerPhObj = {}
            PLPNonExcBannerPhObj.styles = {
              backgroundColor: PLPNonExcBannerObj.banner_color,
              color: PLPNonExcBannerObj.banner_text_color,
              marginTop: '10px'
            }
            PLPNonExcBannerPhObj.text = PLPNonExcBannerObj.tag_text
            PLPNonExcBannerPhObj.status = PLPNonExcBannerObj.status
            return PLPNonExcBannerPhObj
          }
        }
      },
      bannerPlaceHolderForAPPCashBack: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() &&
            bannerData.status === true &&
            bannerData.product_type.toLowerCase() === 'APP_CASHBACK_WEB'.toLowerCase())
          if (bannerObj && Object.keys(bannerObj).length) {
            let PLPNonExcBannerPhObj = {}
            PLPNonExcBannerPhObj.styles = {
              backgroundColor: bannerObj.banner_color,
              color: bannerObj.banner_text_color
            }
            PLPNonExcBannerPhObj.text = bannerObj.tag_text
            PLPNonExcBannerPhObj.status = bannerObj.status
            return PLPNonExcBannerPhObj
          }
        }
      },
      messageHeadForAPPCashBack: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() &&
            bannerData.status === true &&
            bannerData.product_type.toLowerCase() === 'EXCLUSIVE_SAVINGS_POPUP_HEADER'.toLowerCase())
          if (bannerObj && Object.keys(bannerObj).length) {
            let PLPNonExcBannerPhObj = {}
            PLPNonExcBannerPhObj.styles = {
              backgroundColor: bannerObj.banner_color,
              color: bannerObj.banner_text_color
            }
            PLPNonExcBannerPhObj.text = bannerObj.tag_text
            PLPNonExcBannerPhObj.status = bannerObj.status
            return PLPNonExcBannerPhObj
          }
        }
      },
      messageListForAPPCashBack: function () {
        let txtMesgArr = []
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          $.each(this.bannerPlcaeHolderData, function (key, bannerData) {
            if (bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() &&
            bannerData.status === true &&
            bannerData.product_type.toLowerCase() === 'EXCLUSIVE_SAVINGS_POPUP'.toLowerCase()) {
              txtMesgArr.push(bannerData.tag_text)
            }
          })
          return txtMesgArr
        }
      },
      isShowBoyGirlTab: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_BOY_GIRL_TABS_PLP_WEB'.toLowerCase())
      },
      bannerPlaceHolderForGstInclusiveLabel: function () {
        const isGstInclusiveLabelObj = this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'GST_INCLUSIVE_LABEL_PLP'.toLowerCase())
        if (isGstInclusiveLabelObj) {
          return isGstInclusiveLabelObj
        }
        return null
      },
      isShowAutoGenderSwitch: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_GENDER_PLP_SEARCH_SWITCH'.toLowerCase())
      },
      isShowAutoSelectedGenderSwitch: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_AUTO_GENDER_FILTER_PLP'.toLowerCase())
      },
      getClosestProductCount () {
        let matchPoint = window.innerHeight
        if (this.nearestProdPositionArr && this.nearestProdPositionArr.length) {
          return this.nearestProdPositionArr.reduce((a, b) => {
            return Math.abs(b.y - matchPoint) <= Math.abs(a.y - matchPoint) ? b : a
          })
        }
      },
      listingType () {
        if (this.$route && this.$route.params) {
          this.urlSlug = this.$route.params.sid
          if (this.$route.redirectedFrom) {
            let parts = this.$route.redirectedFrom.split('/')
            this.urlSlug = parts[2]
          }
          if (['men', 'women', 'explore'].includes(this.$route.params.type)) {
            this.pageType = 'Category Page'
            return 'category'
          } else if (this.$route.params.type) {
            switch (this.$route.params.type) {
              case 'tags':
                this.pageType = 'Tag Page'
                break
              case 'artists':
                this.pageType = 'Artist Page'
                break
            }
            return this.$route.params.type
          }
          this.pageType = 'Tag Page'
          return 'tags'
        }
      },
      currentCat () {
        if (this.$route.params.type && this.$route.params.type === 'artists') {
          return 'artists'
        } else if (this.$route.params.type && this.$route.params.type === 'tags') {
          return 'tags'
        } else if (!this.$route.params.type) {
          return 'tags'
        } else {
          return null
        }
      },
      getFilterChipsData () {
        return this.$refs.filterOptions && this.$refs.filterOptions.getSelectedFilterChips
      },
      isPlpFirstTimeVisited () {
        return this.plpFirstVisit === true
      }
    }
  }
</script>
<style>

.animate-container .animate-card:first-child .VueCarousel-inner .VueCarousel-slide:first-child {
  animation: move 3s ease;
}

.VueCarousel-inner {
  transition: transform 0.2s ease-in-out 0s !important;
}

@keyframes move {
  0% {
    margin-left: 0;
  }
  50% {
    margin-left: -110px;
  }
  100% {
    margin-left: 0;
  }
}

@media screen and (max-width: 480px) {
  .animate-card .VueCarousel-slide {
      visibility: visible;
      flex-basis: 100%;
      width: 100%;
    }
}
</style>
<style scoped>
.minHeight{
  min-height: 325px;
}
.shimmerBgColor{
  background-color: #FCEAE7;
}
.loadingBanner{
    width: 100%;
    height: 366px;
    object-fit: cover;
  }

@media screen and (max-width: 480px) {
  .minHeight{
      min-height: 250px;
    }
  .loadingBanner{
    height: 250px;
  }

}
@media screen and (min-width: 768px) and (max-width: 991px){
    .minHeight{
      min-height: 600px;
    }
    .loadingBanner{
    height: 600px;
  }
  }
  @media screen and (max-width: 768px) {

  }
</style>
<style lang="css" scoped>
  .no-product-list {
    margin: 0px -9px;
  }
  .title-count{color: #878b94;}
  .cashback-app {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.9;

    font-family: 'Source Sans Pro', sans-serif;

    font-size: 17px;

    font-weight: 500;

    font-stretch: normal;

    font-style: normal;

    line-height: 1.25;

    letter-spacing: normal;

    text-align: left;
  }
  .plisting {
    margin-bottom: 0px;
  }

  .fullWidth {
    width: 100%;
  }

  .plisting.disable:before {
    content: none;
  }

  .counter{
    color: #3498db;
    font-size: 18px;
  }

  #innerbanner .carousel-item {
    height: 25em
  }

  [v-cloak] > * {
    display: none
  }

  [v-cloak]::before {
    content: "loading…";
    position: absolute;
    top: 30%;
    left: 0;
    width: 100%;
    text-align: center;
  }

  .filterCol {
    height: 90vh;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 20%;
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    flex: 0 0 20%;
    overflow-x: hidden;
    overflow-y: auto;
    position: sticky;
    top: 60px;
    scrollbar-width: thin;
    /* max-width: 20%; */
  }
  .filterCol::-webkit-scrollbar {
    width: 14px;  /* Adjust the value as needed */
}


  .pro-list {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 80%;
    -ms-flex: 0 0 80%;
    flex: 0 0 80%;
    max-width: 80%;
  }

  .customcheckbox {
    line-height: 1;
    padding: 2px 0;
  }

  .exclusive-bar {
    background-color: #3498db;
    color: #fff;
    padding: 8px 10px;
    margin-left: unset;
    margin-right: unset;
  }
  .app-cashback{
    background-color: #1e9053;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 18px;
    text-align: center;
    color: #ffffff;
  }

  .exclusive-bar.red-bg {
    background-color: #ed2d2f;
  }

  .exclusive-bar .customcheckbox [type="checkbox"]:not(:checked) + label:before,
  .exclusive-bar .customcheckbox [type="checkbox"]:checked + label:before {
    height: 1em;
    width: 1em;
  }

  .customcheckbox [type="checkbox"]:not(:checked) + label,
  .customcheckbox [type="checkbox"]:checked + label,
  .customradio [type="radio"]:not(:checked) + label,
  .customradio [type="radio"]:checked + label {
    position: relative;
    padding-left: 1.25em;
    cursor: pointer;
  }

  .exclusive-bar .customcheckbox {
    line-height: 1.2;
  }

  .plisting.disable:before, .boxdrop.disable:before {
    background: none;
  }

  .carousel {
    margin-bottom: 0;
  }

  .h-auto .lds-ring {
    height: auto;
  }

  .list-header {
    position: relative;
    font-size: 15px;
    margin: 0;
  }
  .load-more-loader img{
    height: 43px;
  }
  .scroll-to-top-btn button {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    font-size: 19px;
    background-color: #117a7a;
    color: white;
    padding: 4px 10px;
    border-radius: 50%;
  }
  .mweb-vedio-height {
    width: 100%;
    height: 380px;
  }
  @media screen and (min-width: 576px) {
    .customcheckbox > label {
      padding-left: 1.25em !important;
    }
  }


  @media screen and (min-width: 768px) {
    .fullWidth {
      padding: 0px 15px;
    }
  }

  @media screen and (max-width: 991px) {
    .filterCol{
      height: auto;
      position: relative;
    }
    .btmpagenav {
      padding: 20px 0 10px 0;
    }
    .counter {
      color: #3498db;
      font-size: 15px;
    }
    .carousel {
      margin-bottom: 0;
    }

    .breadcrumbcustome {
      padding: 0px 0px;
    }

    .filterCol, .pro-list {
      -webkit-box-flex: 0;
      -webkit-flex: 0 0 100%;
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
    }

    .list-header {
      font-size: 14px;
    }
    .exclusive-bar label {
      font-size: 14px;
    }
    .cashback-app {
      font-size: 11px;
      font-family: 'Source Sans Pro', sans-serif;
    }
    .i-image{
      width: 8px !important;
      height: 8px !important;
      margin-top: -2px !important;
    }
  }

  @media screen and (max-width: 768px) {
    .mobile-new-scrollTop {
      background-color: rgba(51,73,91,0.8);
      border-radius: 500px;
      font-size: 12px;
    }
    .exclusive-bar {
      padding: 6px 10px;
    }
    .wishlistIcon.wishlist:before{
      content: "\f08a";
      color: #000;
    }
    .wishlistIcon.wishlist {
      box-shadow: none;
      background:transparent;
    }
    .wishlistIcon {
      top: unset;
      bottom: 21.6%;
      right: 10px;
    }
    .wishlistAnimation {
      animation: mymove 1s;
    }
    @keyframes mymove {
      100% {transform: rotateY(360deg);}
    }
    .wishlistIcon:hover, .wishlistIcon.wishlistActive {
      background: transparent;
      box-shadow: none;
    }
  }

  .product-item {
    margin: 14px 0;
  }
</style>

<style>
/* star wars page */
  .lined-header {
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 400;
    font-size: 16px;
    text-transform: uppercase;
    position: relative;
    text-align: center;
    display: block;
    float: left;
    width: 100%;
    line-height: 35px;
  }

  .lined-header:before {
    position: absolute;
    top: 45%;
    z-index: 1;
    display: block;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    content: "";
  }

  .lined-header h2 {
    position: relative;
    z-index: 1;
    margin: 0;
    padding: 0 20px;
    background: #fff;
    display: inline-block;
    font-family: 'Source Sans Pro', sans-serif;
font-weight: 700;
    font-size: 24px;
  }

  .dark-mode .lined-header:before {
    border-top: 3px solid #A00F14;
  }


  .dark-mode .lined-header h2 {
    background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-dark.jpg');
    color: white;
  }

  .light-mode .lined-header:before {
    border-top: 3px solid #3689D9;
  }

  .light-mode .lined-header h2 {
    background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-light.jpg');
    color: #3689D9;
  }


  .dark-mode {
    background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-dark.jpg');
    background-repeat: repeat;
    background-attachment: fixed;
    color: #cccccc;
    transition: background 0.4s ease-in-out;
  }

  body.dark-mode .topbar {
    background: #A00F14;
  }

  .dark-mode .dropdown.active {
    background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-dark.jpg');
  }

  .dark-mode sup {
    color: #A00F14 !important;
  }

  .dark-mode .footerlinks ul li a {
     color: #cccccc;
  }

  .dark-mode .bg-faded{
     background: #333333;
     background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-dark.jpg');
  }

  .dark-mode #navbarNavDropdown {
    background: #333333;
    background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-dark.jpg');
    border: none;
  }

  .dark-mode .navbar-collapse.activenav ul.navbar-nav li, .dark-mode .navheader {
    border-color: transparent;
  }

  .dark-mode .navbar-light .navbar-toggler-icon {
    filter: invert(1);
  }

  .dark-mode .selectcolor {
    color: #A00F14;
  }

  .dark-mode .navbar-light .navbar-nav .nav-link {
    background: #333333;
    background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-dark.jpg');
    color: #cccccc;
  }

  .dark-mode .dropdown-menu {
    background: #333333;
    border-bottom: none;
    border-top: #222222;
  }

  .dark-mode .submenucontainer .submenu li a {
    color: #cccccc;
  }

  .dark-mode .fa-search:before,
  .dark-mode .fa-user-o,
  .dark-mode .fa-shopping-cart {
    color: #A00F14;
  }

  .dark-mode .newbread {
    color: #A00F14;
    font-weight: bold;
  }

  .dark-mode .breadcrumbcustome {
    border-color: transparent;
    color: #cccccc;
  }

  .dark-mode .pagination ul li,
  .dark-mode .pagination ul li .circle-icon.active{
     color: white;
  }

  .dark-mode .artUsericon {
    border-bottom: none;
  }

  .dark-mode .collapsing {
    background: #333333;
    background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-dark.jpg');
  }

  .dark-mode .collapse.show {
    background: #333333;
    background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-dark.jpg');
  }

  .dark-mode .artUsericon img{
    border: 3px solid #A00F14;
  }

  .dark-mode .stickyfilter,.dark-mode .filterbtns  {
    background: #333333;
    background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-dark.jpg');
  }

  .dark-mode .leftsidebar {
    border: none;
  }

  .dark-mode .filter-search {
    background: transparent;
    color: white
  }

  .dark-mode .custaccordian .card {
    border: none;
  }

  .dark-mode .custaccordian .card-header a  {
    background: #333333;
    background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-dark.jpg');
    color: #ccc;
  }

  .dark-mode .btn-outline-primary {
    border-color: #ed2d2f;
    color: #ed2d2f;
  }

  .dark-mode .btn-outline-primary:hover {
    background: #ed2d2f;
    color: #cccccc;
  }

  .dark-mode .listhover {
    border: 3px solid #A00F14;
  }

  .dark-mode .productlist h5 {
    border-bottom: 1px rgba(255, 255, 255, 0.13) solid;
    color:#ed2d2f;
  }

  .dark-mode .listprice {
    color: #cccccc;
  }

  .dark-mode .stickyfooter .thm1 {
    background: #333333;
  }

  .dark-mode footer  {
    background: #333333;
  }

  .dark-mode #search {
    background: #222222;
    color: white !important;
  }

  .dark-mode .search:hover input#search, .search input#search:focus {
    background: #222222;
  }

  .light-mode {
    background-attachment: fixed;
    color: #333333;
    transition: background 0.4s ease-in-out;
  }

  body.light-mode {
    background-image: url('https://tss-static-images.gumlet.io/star-wars/bg-light.jpg');
  }

  .light-mode .offer{
    color: #3689D9;
  }

  .light-mode .navbar-collapse.activenav ul.navbar-nav li, .light-mode .navheader {
    border-color: transparent;
  }

  .light-mode .selectcolor {
    color: #3689D9;
  }

  .light-mode .fa-search:before,
  .light-mode .fa-user-o,
  .light-mode .fa-shopping-cart {
    color: #3689D9;
  }

  .light-mode sup {
    color: #3498db !important;
  }

  .light-mode .newbread {
    color: #3689D9;
    font-weight: bold;
  }

  .light-mode .breadcrumbcustome {
    border-color: transparent;
  }

  .light-mode .artUsericon {
    border-bottom: none;
  }

  .light-mode .artUsericon img{
    border: 3px solid #3689D9;
  }

  .light-mode .custaccordian .card {
    border: none;
  }

  .light-mode .btn-outline-primary {
    border-color: #3689D9;
    color: #3689D9;
  }

  .light-mode .btn-outline-primary:hover {
    background: #3689D9;
    color: white;
  }

  .light-mode .listhover {
    border: 3px solid #3689D9;
  }

  .light-mode .productlist h5 {
    color:#3689D9;
  }
  .wishlistIcon{
    width: 30px;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    text-align: center;
    line-height: 30px;
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 92;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.16);
    cursor: pointer;
  }
  .wishlistIcon:before{
    font: normal normal normal 14px/1.5 FontAwesome;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    content: "\f08a";
    color: #fff;
  }
  .wishlistIcon:hover,
  .wishlistIcon.wishlistActive{
    background-color: #ffffff;
  }
  .wishlistIcon:hover:before,
  .wishlistIcon.wishlistActive:before{
    content: '\f004';
    color: #117a7a;
  }
  .wishlistIcon.wishlist{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.16);
    background-color: rgba(0, 0, 0, 0.2);
  }

  .wishlistIcon.wishlist:before{
    content: "\f08a";
    color: #fff;
  }

</style>
<style>
.mweb-vedio-height video {
    object-fit: fill !important;
  }
  @media screen and (max-width: 768px) {
    .mweb-vedio-height {
      height: calc(100vw / 2) !important;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// listing.vue?4b2a38e8